import { render, staticRenderFns } from "./ReportByProduct.vue?vue&type=template&id=b5badd7c&scoped=true&"
import script from "./ReportByProduct.vue?vue&type=script&lang=js&"
export * from "./ReportByProduct.vue?vue&type=script&lang=js&"
import style0 from "./ReportByProduct.vue?vue&type=style&index=0&id=b5badd7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5badd7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VCombobox,VFlex,VLayout,VTreeview})
